import React from "react";
import { Button } from "@mui/material";
import { ShoppingCart as ShoppingCartIcon } from "../icons";
import { useNavigate } from "react-router-dom";
import { auth } from "../firebase";
import { T } from "../routes/Translate";
import { offerSellsWithPaypal, getOfferFinalPrice } from "../routes/homeUtils";
import { brandColors } from "../theme";

// "Comprar con PayPal" de una oferta con cobro en Notiline. No se muestra en
// las ofertas propias. Sin sesión, /offers/:id/checkout (ProtectedRoute)
// manda a iniciar sesión y vuelve.
const OfferBuyButton = ({ offer, sx }) => {
  const navigate = useNavigate();
  if (!offerSellsWithPaypal(offer) || offer.uid === auth.currentUser?.uid) return null;

  return (
    <Button
      fullWidth
      variant="contained"
      startIcon={<ShoppingCartIcon />}
      onClick={() => navigate(`/offers/${offer.id}/checkout`)}
      sx={{
        textTransform: "none",
        fontWeight: 600,
        bgcolor: brandColors.primary,
        color: "white",
        "&:hover": { bgcolor: brandColors.primaryHover },
        mt: 1,
        ...sx,
      }}
    >
      <T>Comprar con PayPal</T> (${getOfferFinalPrice(offer).toFixed(2)})
    </Button>
  );
};

export default OfferBuyButton;
